/**
 * @generated SignedSource<<7adea7a7b675c2250f596dbb42a580f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BlogPostStatusEnum = "approved" | "draft" | "published";
import { FragmentRefs } from "relay-runtime";
export type BlogPostContent_BlogPost$data = {
  readonly blogCategories: ReadonlyArray<{
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
  }> | null | undefined;
  readonly blogSubcategories: ReadonlyArray<{
    readonly blogCategory: {
      readonly slug: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
  }> | null | undefined;
  readonly content: string | null | undefined;
  readonly slug: string | null | undefined;
  readonly status: BlogPostStatusEnum | null | undefined;
  readonly title: string | null | undefined;
  readonly user: {
    readonly id: string;
    readonly self: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"MetaInfo_BlogPostFragment">;
  readonly " $fragmentType": "BlogPostContent_BlogPost";
};
export type BlogPostContent_BlogPost$key = {
  readonly " $data"?: BlogPostContent_BlogPost$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostContent_BlogPost">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogPostContent_BlogPost",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "self",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BlogCategory",
      "kind": "LinkedField",
      "name": "blogCategories",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BlogSubcategory",
      "kind": "LinkedField",
      "name": "blogSubcategories",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BlogCategory",
          "kind": "LinkedField",
          "name": "blogCategory",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MetaInfo_BlogPostFragment"
    }
  ],
  "type": "BlogPost",
  "abstractKey": null
};
})();

(node as any).hash = "978f9f75bd002e4bde9cc4cbd0e1167c";

export default node;
